import router from './router'
import { useAppStoreWithOut } from '@/store/modules/app'
import type { RouteRecordRaw } from 'vue-router'
import { useTitle } from '@/hooks/web/useTitle'
import { useNProgress } from '@/hooks/web/useNProgress'
import { usePermissionStoreWithOut } from '@/store/modules/permission'
import { usePageLoading } from '@/hooks/web/usePageLoading'
import { NO_REDIRECT_WHITE_LIST } from '@/constants'
import { useUserStoreWithOut } from '@/store/modules/user'
import { findFirstVisibleRoute } from '@/utils/routerHelper'
import { computed, unref } from 'vue'

const { start, done } = useNProgress()

const { loadStart, loadDone } = usePageLoading()

router.beforeEach(async (to, from, next) => {
  start()
  loadStart()
  const permissionStore = usePermissionStoreWithOut()
  const appStore = useAppStoreWithOut()
  const userStore = useUserStoreWithOut()
  const layout = computed(() => appStore.getLayout)

  if (userStore.getUserInfo) {
    if (to?.path === '/login') {
      next({ path: '/' })
    } else {
      if (to?.path === '/404') {
        // 这个判断就是要用userStore.getRoleRouters这个是登录进来后端返回的动态路由
        if (userStore.getRoleRouters?.length && userStore.getToken) {
          // 这一行用这个permissionStore.getTopLeftRouters数据主要是为了解决布局模式为topLeft时，页面404后左侧菜单显示有问题
          const firstVisibleRoute = findFirstVisibleRoute(permissionStore.getTopLeftRouters)
          if (firstVisibleRoute?.visibleRoutePath) {
            if (unref(layout) === 'topLeft') {
              permissionStore.setRouters([firstVisibleRoute])
            }
            next({ path: firstVisibleRoute.visibleRoutePath })
          } else {
            userStore.reset()
            next()
          }
        } else {
          userStore.reset()
          next()
        }
        return
      }

      if (permissionStore.getIsAddRouters) {
        next()
        return
      }

      // 开发者可根据实际情况进行修改
      const roleRouters = userStore.getRoleRouters || []

      // 是否使用动态路由
      if (appStore.getDynamicRouter) {
        appStore.serverDynamicRouter
          ? await permissionStore.generateRoutes('server', roleRouters as AppCustomRouteRecordRaw[])
          : await permissionStore.generateRoutes('frontEnd', roleRouters as string[])
      } else {
        await permissionStore.generateRoutes('static')
      }

      permissionStore.getAddRouters.forEach((route) => {
        router.addRoute(route as unknown as RouteRecordRaw) // 动态添加可访问路由表
      })

      if (unref(layout) === 'topLeft') {
        // 解决布局模式为topLeft时，刷新浏览器左侧菜单会显示所有菜单的问题(必须要在-是否使用动态路由和动态添加路由-之后)
        permissionStore.setRouters(
          permissionStore.getTopLeftRouters.filter((v) => v.path === `/${to.path.split('/')[1]}`)
        )
      }

      const redirectPath = from.query.redirect || to?.path
      const redirect = decodeURIComponent(redirectPath as string)
      const nextData = to?.path === redirect ? { ...to, replace: true } : { path: redirect }
      permissionStore.setIsAddRouters(true)
      next(nextData)
    }
  } else {
    if (NO_REDIRECT_WHITE_LIST.indexOf(to?.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to?.path}`) // 否则全部重定向到登录页
    }
  }
})

router.afterEach((to) => {
  useTitle(to?.meta?.title as string)
  done() // 结束Progress
  loadDone()
})
